// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text {
    color: black;
}

@media (max-width: 767px) {
    .text {
        color: white !important;
    }
}

.inputtext::placeholder {
    color: black;
}

@media (max-width: 767px) {
    .inputtext::placeholder {
        color: white !important;
    }
}

.select-dropdown {
    background-color: transparent;
}

@media (max-width: 767px) {
    .select-dropdown {
        background-color: black !important;
    }

    .select-dropdown:focus {
        background-color: black !important;
    }
}

@media (min-width: 768px) {
    .select-dropdown {
        background-color: white !important;
    }

    .select-dropdown:focus {
        background-color: white !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Login&Register/LoginRegister.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;AACJ","sourcesContent":[".text {\n    color: black;\n}\n\n@media (max-width: 767px) {\n    .text {\n        color: white !important;\n    }\n}\n\n.inputtext::placeholder {\n    color: black;\n}\n\n@media (max-width: 767px) {\n    .inputtext::placeholder {\n        color: white !important;\n    }\n}\n\n.select-dropdown {\n    background-color: transparent;\n}\n\n@media (max-width: 767px) {\n    .select-dropdown {\n        background-color: black !important;\n    }\n\n    .select-dropdown:focus {\n        background-color: black !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .select-dropdown {\n        background-color: white !important;\n    }\n\n    .select-dropdown:focus {\n        background-color: white !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
